import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { AuthGuard } from './services/auth-guard';

import { AppPublicComponent } from './app-public.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { TruckLoadListComponent } from './pages/loads/truck-load-list/truck-load-list.component';
import { WhStockListComponent } from './pages/loads/wh-stock/wh-stock-list.component';
import { OrdersRequestComponent } from './pages/loads/orders-request/orders-request.component';
import { CreateRequestComponent } from './pages/loads/create-request/create-request.component';
import { RequestListComponent } from './pages/loads/request-list/request-list.component';
import { MovementReportComponent } from './pages/loads/movement-report/movement-report.component';
import { StockTranferWarehousesComponent } from './pages/loads/stock-tranfer-warehouses/stock-tranfer-warehouses.component';
import { RequestEditingComponent } from './pages/loads/request-editing/request-editing.component';
import { TruckLoadDetailComponent } from "./pages/loads/truck-load-detail/truck-load-detail.component";
import { StockInventoryComponent } from "./pages/loads/stcok-inventory/stock-inventory.component";
import {PendingRequestListComponent} from './pages/loads/pending-request-list/pending-request-list.component';
import { InlandCargoListComponent } from './pages/loads/inland-cargo-list/inland-cargo-list.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppMainComponent,
                children: [
                    { path: '', component: DashboardComponent, canActivate: [AuthGuard], data: {title: 'Dashboard', useSearch: true} },
                    { path: 'loads/truckLoadList', component: TruckLoadListComponent, canActivate: [AuthGuard], data: {title: 'Yurtiçi Dağıtım Listesi', useSearch: true}},
                    { path: 'loads/truckLoad/:id', component: TruckLoadDetailComponent, canActivate: [AuthGuard],  },
                    { path: 'loads/whstocklist', component: WhStockListComponent, canActivate: [AuthGuard],  data: {title: 'Stok Listesi', useSearch: true}},
                    { path: 'loads/orders-request', component: OrdersRequestComponent, canActivate: [AuthGuard], data: {title: 'Sipariş Talepler', useSearch: true}},
                    { path: 'loads/create-request', component: CreateRequestComponent, canActivate: [AuthGuard],data: {title: 'Talep Oluştur', useSearch: false} },
                    { path: 'loads/request-list', component: RequestListComponent, canActivate: [AuthGuard], data: {title: 'Talep Oluştur', useSearch: true} },
                    { path: 'loads/stock-transfer-warehouses', component: StockTranferWarehousesComponent, canActivate: [AuthGuard],  data: {title: 'Depolar Arası Transfer Listesi', useSearch: true} },
                    { path: 'loads/stock-inventory', component: StockInventoryComponent, canActivate: [AuthGuard], data: {title: 'Ürün Giriş Listesi', useSearch: true} },
                    { path: 'loads/movement-report', component: MovementReportComponent, canActivate: [AuthGuard], data: {title: 'Hareket Raporu', useSearch: true}},
                    { path: 'loads/request-editing', component: RequestEditingComponent, canActivate: [AuthGuard],  data: {title: 'Talep Düzenle', useSearch: true}},
                    { path: 'loads/pending-request-list', component: PendingRequestListComponent, canActivate: [AuthGuard],  data: {title: 'Beklenen Talepler', useSearch: true}},

                    { path: 'loads/inlandCargoList', component: InlandCargoListComponent, canActivate: [AuthGuard],  data: {title: 'Yurtiçi Kargo Listesi', useSearch: true}},

                ]
            },
            {
                path: '', component: AppPublicComponent,
                children: [
                ]
            },
            { path: 'error', component: AppErrorComponent },
            { path: 'access', component: AppAccessdeniedComponent },
            { path: 'notfound', component: AppNotfoundComponent },
            { path: 'login', component: AppLoginComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
